import { render, staticRenderFns } from "./SmTextPrintSizeAnnounce.vue?vue&type=template&id=37aa064a&"
import script from "./SmTextPrintSizeAnnounce.vue?vue&type=script&lang=ts&"
export * from "./SmTextPrintSizeAnnounce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports